export function checkPhoneNumber(phone, vm) {
  var mobile = phone.number;
  var checked = phone.code === 86 ? /^1[3-9]\d{9}$/.test(mobile) : /^\d{6,}$/.test(mobile);

  if (!checked && vm) {
    vm.$emit('error', {
      action: 'bindphone',
      type: vm.bindphoneType,
      error: new Error('请填写正确的手机号码')
    });
  }

  return checked;
}
export function checkEmail(email, vm) {
  var checked = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email);

  if (!checked && vm) {
    vm.$emit('error', {
      action: 'emailLogin',
      type: vm.bindphoneType,
      error: new Error('请填写正确的邮箱号')
    });
  }

  return checked;
}
export function checkCaptcha(captcha, vm) {
  var checked = /^\d{6}$/.test(captcha);

  if (!checked && vm) {
    vm.$emit('error', {
      action: 'bindphone',
      type: vm.bindphoneType,
      error: new Error('请填写正确的验证码')
    });
  }

  return checked;
}